import { useState } from 'react';

import { validators } from '@/shared/utils/validator';

import { ContactUsForm } from '../types/ContactUsFormTypes';

export const useValidateContact = (contactUsForm: ContactUsForm) => {
  const [errors, setErrors] = useState({
    email: '',
    companyName: '',
    representativeName: '',
    phoneNumber: '',
    businessRegistrationNumber: '',
    termsOfServiceAgree: '',
    content: '',
  });

  const validateContact = () => {
    const newErrors: typeof errors = {
      email: '',
      companyName: '',
      representativeName: '',
      phoneNumber: '',
      businessRegistrationNumber: '',
      termsOfServiceAgree: '',
      content: '',
    };

    // 이메일
    const emailValidation = validators.email(contactUsForm.email);
    if (!emailValidation.valid) {
      newErrors.email = emailValidation.error;
    }

    // 회사명
    const companyNameValidation = validators.companyName(
      contactUsForm.companyName,
    );
    if (!companyNameValidation.valid) {
      newErrors.companyName = companyNameValidation.error;
    }

    // 대표자명
    const representativeNameValidation = validators.representativeName(
      contactUsForm.representativeName,
    );
    if (!representativeNameValidation.valid) {
      newErrors.representativeName = representativeNameValidation.error;
    }

    // 사업자등록번호
    const businessRegistrationValidation =
      validators.businessRegistrationNumber(
        contactUsForm.businessRegistrationNumber,
      );
    if (!businessRegistrationValidation.valid) {
      newErrors.businessRegistrationNumber =
        businessRegistrationValidation.error;
    }

    // 전화번호
    const phoneNumberValidation = validators.phoneNumber(
      contactUsForm.phoneNumber,
    );
    if (!phoneNumberValidation.valid) {
      newErrors.phoneNumber = phoneNumberValidation.error;
    }

    // 내용
    const contentValidation = validators.content(contactUsForm.content, {
      minLength: 1,
      maxLength: 20000,
    });
    if (!contentValidation.valid) {
      newErrors.content = contentValidation.error;
    }

    // 약관 동의
    const termsOfServiceAgreeValidation = validators.termsOfServiceAgree(
      contactUsForm.termsOfServiceAgree,
    );
    if (!termsOfServiceAgreeValidation.valid) {
      newErrors.termsOfServiceAgree = termsOfServiceAgreeValidation.error;
    }

    setErrors(newErrors);
    // 에러가 하나라도 있으면 false 반환
    return Object.values(newErrors).every(
      (errorMessage) => errorMessage === '',
    );
  };

  return { validateContact, errors };
};
